import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["suffix", "percentageHint"]
  static values = { currencyUnit: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const percentage = this.percentageSelected()

    this.suffixTarget.dataset.suffix = percentage ? "%" : this.currencyUnitValue
    this.percentageHintTarget.classList.toggle("d-none", !percentage)
  }

  percentageSelected() {
    const checked = this.element.querySelector("input[name$='[management_fees_type]']:checked")

    return checked?.value === "percentage"
  }
}
